if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.popup = document.getElementById('loading-popup');

      // Shopify Collab - Sync URL params to cookies
      this.syncCollabParamsToCookies();
    }

    syncCollabParamsToCookies() {
      const params = new URLSearchParams(window.location.search);
      const discountCode = params.get('discount_code');
      const giftProduct = params.get('gift_product');

      // Set cookie for 3 months (90 days)
      const expiryDays = 90;

      if (discountCode) this.setCookie('collab_discount_code', discountCode, expiryDays);
      if (giftProduct) this.setCookie('collab_gift_product', giftProduct, expiryDays);
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    getCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          if (this.cartDrawer != null) {
            // Check for Shopify Collab parameters
            this.handleShopifyCollabGift().then(() => {
              fetchCart().then((cart) => {
                this.cartDrawer.open(cart);
                this.cartDrawer.setActiveElement(document.activeElement);
                document.dispatchEvent(cartUpdateEvent);
              });
            });
          } else {
            console.error('Cart drawer returns null');
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async handleShopifyCollabGift() {
      try {
        const isEligible = this.getAttribute('data-free-gift') === 'true';
        const dtId = this.getCookie('dt_id');

        // Check if eligible and has collab ID
        if (!isEligible || !dtId) {
          return;
        }

        const giftProductId = this.getCookie('collab_gift_product');
        const discountCode = this.getCookie('collab_discount_code');

        // If no Shopify Collab parameters found in cookies, return early
        if (!giftProductId || !discountCode) {
          return;
        }

        // Fetch current cart to check if gift is already there
        const cart = await fetch('/cart.js').then(res => res.json());

        const giftProductIdNum = Number(giftProductId);
        const isGiftInCart = cart.items.some(item => item.variant_id === giftProductIdNum);

        // Check if discount is already applied
        const isDiscountApplied = cart.discount_codes?.some(
          code => code.code.toUpperCase() === discountCode.toUpperCase()
        );

        // If both gift and discount are already applied, skip
        if (isGiftInCart && isDiscountApplied) {
          return;
        }

        // Show loading popup
        this.showPopup('Adding your free gift and discount...');

        // Add gift product if not already in cart
        if (!isGiftInCart) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: giftProductIdNum,
                quantity: 1,
                properties: { '_gift_source': 'SHOPIFY_COLLAB' }
              }]
            })
          });
        }

        // Apply discount code if not already applied
        if (!isDiscountApplied) {
          if (typeof applyDiscountCode === 'function') {
            await applyDiscountCode(discountCode);
          } else {
            console.warn('applyDiscountCode function not found. Falling back to /discount endpoint.');
            await fetch(`/discount/${discountCode}`);
          }
        }

        // Hide loading popup
        this.hidePopup();

        // Dispatch cart update event
        document.dispatchEvent(cartUpdateEvent);

      } catch (error) {
        console.error('Error handling Shopify Collab gift:', error);

        // Hide loading popup on error
        this.hidePopup();
      }
    }

    showPopup(customMessage = 'Adding your free gift to the cart...') {
      if (this.popup) {
        this.popup.style.display = 'flex';
        this.popup.setAttribute('aria-hidden', 'false');
        if (customMessage) {
          this.popup.querySelector('#loading-message').textContent = customMessage;
        }
      }
    }

    hidePopup() {
      if (this.popup) {
        this.popup.style.display = 'none';
        this.popup.setAttribute('aria-hidden', 'true');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
